import { render, staticRenderFns } from "./groupCustomer_item.vue?vue&type=template&id=10972c26"
import script from "./groupCustomer_item.vue?vue&type=script&lang=js"
export * from "./groupCustomer_item.vue?vue&type=script&lang=js"
import style0 from "./groupCustomer_item.vue?vue&type=style&index=0&id=10972c26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports